module.exports = __webpack_public_path__ + "static/heromobile-99bb2bf3053ff0b4b0ca9f32bd84d474.jpg";